import { Route } from '@angular/router';
import { IsAdminGuard, LoggedInGuard } from '@spotter/guards/login-guard';

/** Adds the tools pages routes. */
export function addToolsRoutes(): Route[] {
  return [
    {
      path: 'tools/bulk-upload', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/sightings/bulk-upload-page/bulk-upload-page.component').then(m => m.BulkUploadPageComponent)
    },
    {
      path: 'tools/bulk-upload-help', canActivate: [LoggedInGuard],
      loadComponent: () => import('../pages/tools/bulk-upload-help/bulk-upload-help.page').then(m => m.BulkUploadHelpPage)
    },
    {
      path: 'tools/translations',
      loadComponent: () => import('../pages/tools/translations/translations.page').then(m => m.TranslationsPage)
    },
    {
      path: 'tools/bulk-delete', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/bulk-delete/bulk-delete.page').then(m => m.BulkDeletePage)
    },
  ];
}